'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _requestPromise = require('request-promise');

var _requestPromise2 = _interopRequireDefault(_requestPromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EMBED = 'embed[]=';

var TVMaze = function () {
  function TVMaze() {
    var url = arguments.length <= 0 || arguments[0] === undefined ? 'https://api.tvmaze.com/' : arguments[0];

    _classCallCheck(this, TVMaze);

    this.APIURL = url;
  }

  _createClass(TVMaze, [{
    key: 'findShow',
    value: function findShow(searchString) {
      return (0, _requestPromise2.default)({ url: this.APIURL + 'search/shows/?q=' + searchString, json: true });
    }
  }, {
    key: 'getShow',
    value: function getShow(tvMazeId, embed) {
      var extra = '';

      if (embed) {
        extra = '?' + EMBED + embed.join('&' + EMBED);
      }

      return (0, _requestPromise2.default)({ url: this.APIURL + 'shows/' + tvMazeId + extra, json: true });
    }
  }, {
    key: 'getEpisodes',
    value: function getEpisodes(tvMazeId) {
      return (0, _requestPromise2.default)({ url: this.APIURL + 'shows/' + tvMazeId + '/episodes', json: true });
    }
  }, {
    key: 'getEpisodeById',
    value: function getEpisodeById(tvMazeEpisodeId) {
      return (0, _requestPromise2.default)({ url: this.APIURL + 'episodes/' + tvMazeEpisodeId, json: true });
    }
  }, {
    key: 'getCast',
    value: function getCast(tvMazeId) {
      return (0, _requestPromise2.default)({ url: this.APIURL + 'shows/' + tvMazeId + '/cast', json: true });
    }
  }, {
    key: 'getUpdates',
    value: function getUpdates() {
      return (0, _requestPromise2.default)({ url: this.APIURL + 'updates/shows', json: true });
    }
  }]);

  return TVMaze;
}();

exports.default = TVMaze;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tvmaze/lib/index.js
// module id = 427
// module chunks = 0